/** Keeps focus in the embedded onboarding chat textarea after send / field scroll. */
export function restoreChatInputFocus(): void {
  const textarea = document.querySelector('.ai-chat-body .ai-textarea textarea')
  if (textarea instanceof HTMLTextAreaElement) {
    textarea.focus({ preventScroll: true })
  }
}
